export function onPopstateCaptured(handler: () => void): () => void {
  window.addEventListener('popstate', handler, { capture: true });
  return () =>
    window.removeEventListener('popstate', handler, { capture: true });
}
